import { render, staticRenderFns } from "./DamageCalc.vue?vue&type=template&id=4dc9ab2e&scoped=true&"
import script from "./DamageCalc.vue?vue&type=script&lang=js&"
export * from "./DamageCalc.vue?vue&type=script&lang=js&"
import style0 from "./DamageCalc.vue?vue&type=style&index=0&id=4dc9ab2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9ab2e",
  null
  
)

export default component.exports